<template>
<div class="mb-4 filtergroup">
  <div class="block filter-group_wrapper" v-for="filtergroup in filters" v-bind:key="filtergroup.name">
    <h4>{{ filtergroup.name }}</h4>
    <label class="block font-bold" v-for="filter in filtergroup.items" v-bind:key="filter.item">
      <input class="mr-2 leading-tight" type="checkbox" :value="filter.item" v-model="checkedFilters" v-on:change="updatefilters">
      <span class="text-sm">
        {{ filter.item }}
        <!-- span class="count text-grey">(
          {{ filter.count }}
        )</span -->
      </span>
    </label>
  </div>
</div>
</template>

<script>
export default {
  name: 'Features',
  data () {
    return {
      checkedFilters: []
    }
  },
  methods: {
    updatefilters: function (event) {
      this.$store.commit('ADD_FILTER', {
        type: 'features',
        filters: this.checkedFilters
      })
    }
  },
  computed: {
    filters () {
      return this.$store.getters.features
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/features.vue